export type FieldType = 'text' | 'number' | 'date' | 'dropdown' | 'checkbox' | 'signature' | 'radio';

export interface TemplateField {
  id: string;
  type: FieldType;
  label: string;
  variableName: string;
  required: boolean;
  placeholder: string;
  minValue?: number;
  maxValue?: number;
  minLength?: number;
  maxLength?: number;
  defaultValue?: string;
  validationPattern?: string;
  options?: string[];
}

export interface FieldTypeDef {
  type: FieldType;
  label: string;
  icon: string;
}

export const FIELD_TYPE_DEFS: FieldTypeDef[] = [
  { type: 'text', label: 'Text Input', icon: 'bx bx-text' },
  { type: 'number', label: 'Number', icon: 'bx bx-hash' },
  { type: 'date', label: 'Date', icon: 'bx bx-calendar' },
  // { type: 'dropdown', label: 'Dropdown', icon: 'bx bx-chevron-down-square' },
  { type: 'checkbox', label: 'Checkbox', icon: 'bx bx-check-square' },
  // { type: 'signature', label: 'Signature', icon: 'bx bx-edit-alt' },
  { type: 'radio', label: 'Radio Button', icon: 'bx bx-radio-circle-marked' },
];

export function hasOptionsList(type: FieldType): boolean {
  return type === 'dropdown' || type === 'radio';
}

export function supportsMinMaxValue(type: FieldType): boolean {
  return type === 'number' || type === 'date';
}

export function supportsMinMaxLength(type: FieldType): boolean {
  return type === 'text';
}

export function supportsValidationPattern(type: FieldType): boolean {
  return type === 'text' || type === 'number';
}
